import { render } from "./edit.vue?vue&type=template&id=74625b85&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=74625b85&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74625b85"],['__file',"src/views/food/restaurant/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74625b85"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74625b85', __exports__)) {
    console.log('reload')
    api.reload('74625b85', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=74625b85&scoped=true", () => {
    console.log('re-render')
    api.rerender('74625b85', render)
  })

}


export default __exports__